export const USERS_LIST = [
    {
        "name": "Suman sen",
        "location": "Chittaranjan",
        "type": "employee",
        "phone": "+918759501327",
        "image": ""
    },
    {
        "name": "Vaibhav baghel",
        "location": "Gurgaon",
        "type": "employee",
        "phone": "+916542230120",
        "image": ""
    },
    {
        "name": "Sumit das",
        "location": "City center, Durgapur",
        "type": "user",
        "phone": "+919823001144",
        "image": ""
    },
    {
        "name": "Avik majumdar",
        "location": "Park street, Kolkata",
        "type": "admin",
        "phone": "+910332563201",
        "image": ""
    },
    {
        "name": "Debasish bouri",
        "location": "sepco township, durgapur",
        "type": "owner",
        "phone": "+916523145200",
        "image": ""
    }
]
